<template>
  <div class="c-post">
    <div v-if="post.content.main" class="c-msg" v-html="formatMsg(post.content.main)"></div>

    <div>
      <div class="c-om-ttl">{{ $T('attributes.open_method') }}</div>
      <div class="c-om-r">{{ openMethod }}</div>
    </div>

    <div class="c-explain">{{ $T('post.enquete.explain.unknown') }}</div>

    <div v-if="qs">
      <v-text-field class="c-dummy" v-model="data.d" />
      <div class="c-q" v-for="(q, i) in qs">
        <div class="c-flex">
          <div class="c-ql">Q{{ i + 1 }}.</div>
          <div class="c-qc s">{{ q.q.v }}</div>
        </div>
        <div class="c-ans-area">
          <div v-if="q.o" class="c-required">{{ $T('post.enquete.optional') }}</div>
          <template v-if="q.t == 't'">
            <v-textarea
              v-model="data.ans[q.q.md5].t"
              counter="1000"
              solo
              @input="validate(q.q.md5)"
              :errorMessages="toErrs(q.q.md5)"
              color="clr-primary"
              class="c-intm"
              :disabled="isGuest || isExpired || noAnswer"
            />
          </template>
          <template v-else-if="q.t == 's'">
            <v-radio-group
              v-model="data.ans[q.q.md5].v"
              :errorMessages="toErrs(q.q.md5)"
              color="clr-primary"
              class="c-ntm lsmart"
              :disabled="isGuest || isExpired || noAnswer"
              @change="validate(q.q.md5)"
            >
              <v-radio v-for="(a, aidx) in q.as" :key="aidx" :label="a.v" :value="a.md5" color="clr-primary" />
            </v-radio-group>
          </template>
          <template v-else-if="q.t == 'm'">
            <v-checkbox
              v-for="(a, aidx) in q.as"
              :key="aidx"
              v-model="data.ans[q.q.md5].vs"
              :label="a.v"
              :value="a.md5"
              color="clr-primary"
              class="c-ntm smart"
              :disabled="isGuest || isExpired || noAnswer"
              @change="validate(q.q.md5)"
            />
            <div class="v-messages clr-error--text">{{ toErr(q.q.md5) }}</div>
          </template>
        </div>
      </div>
    </div>

    <div class="c-btn" v-if="!isExpired">
      <v-btn
        v-if="!noAnswer"
        :loading="loading"
        :disabled="isGuest || loading"
        class="c-confirm-btn elevation-6"
        @click="onClicked"
        color="clr-btn"
        round
        dark
        depressed
      >
        <span>{{ $T('common.answer') }}</span>
      </v-btn>
      <v-btn v-else-if="canAnswer" flat color="clr-primary" @click="doAnswer = true"
        ><v-icon left>mdi-pencil</v-icon>{{ $T('post.re-answer') }}</v-btn
      >
    </div>

    <div class="c-result-btn" v-if="!qas">
      <v-btn
        :loading="resultLoading"
        :disabled="!canShowResult || loading"
        class="c-confirm-btn"
        @click="onShowResultClicked"
        color="clr-btn"
        round
        outline
      >
        <v-icon left>mdi-chart-line</v-icon> {{ $T('post.enquete.display_result') }}
      </v-btn>
    </div>

    <div v-if="qas">
      <div class="c-qa-title">{{ $T('post.enquete.result') }}</div>
      <div class="c-q" v-for="(qa, i) in qas">
        <div class="c-flex">
          <div class="c-ql">Q{{ i + 1 }}.</div>
          <div class="c-qc s">{{ qa.q }}</div>
        </div>
        <div class="c-ans-area">
          <template v-if="qa.t == 't'">
            <v-list v-if="qa.as.length > 0">
              <template v-for="(a, idx) in qa.as">
                <v-divider />
                <div class="c-qa-comment" v-html="toComment(a)"></div>
              </template>
              <v-divider />
            </v-list>
            <div v-if="qa.as.length == 0" class="c-nodata">{{ $T('common.no_data') }}</div>
          </template>
          <template v-else-if="qa.t == 's' || qa.t == 'm'">
            <v-list class="c-enq-a-list">
              <template v-for="(a, idx) in qa.as">
                <v-list-tile :key="`a-${qa.t}-${idx}`">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ a[0] }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>{{ a[1] }}</v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CONST } from '../../constant';
import postDetailPlugin from '../../utils/plugin/postDetailPlugin';
import { answerPostEnquete, getSelfAnswer, getEnqueteAnswer } from '../../api/post';
import md5 from 'js-md5';

export default {
  mixins: [postDetailPlugin],
  data() {
    return {
      loading: false,
      resultLoading: false,
      data: {
        ans: {},
        d: '',
      },
      qs: null,
      qas: null,
      doAnswer: false,
      cmids: null,
      listDialog: false,
    };
  },
  mounted() {
    this.initAnswer(this.post);
  },
  watch: {
    post(n, o) {
      this.doAnswer = false;
      this.initAnswer(n);
    },
  },
  computed: {
    noAnswer() {
      return !this.canAnswer || (this.isAnswered && !this.doAnswer);
    },
    openMethod() {
      var open = this.post.content.open;
      if (open == 'anytime') return $T('post.enquete.open.anytime');
      if (open == 'answered') return $T('post.enquete.open.answered');
      if (open == 'ended') return $T('post.enquete.open.ended');
      if (open == 'never') return $T('post.enquete.open.never');
      return 'UNKNOWN';
    },
    canShowResult() {
      var p = this.post;
      var o = p.content.open;
      if (p.creator_cmid == this.cidToCmid(p.community_id) || o == 'anytime') return true;
      if (o == 'never') return false;
      if (o == 'ended') return !this.canAnswer;
      if (o == 'answered') return this.isAnswered;
      return false;
    },
  },
  methods: {
    toErr(md5) {
      return this.data.ans[md5].e;
    },
    toErrs(md5) {
      var e = this.toErr(md5);
      return e ? [e] : [];
    },
    validate(md5) {
      var d = this.data;
      for (var q of this.qs) {
        if (md5 != q.q.md5) continue;
        var a = d.ans[md5];
        a.e = null;
        if (q.t == 't') {
          var v = a.t;
          if (!v) {
            if (!q.o) {
              a.e = $T('validation.just_required');
              return false;
            }
          } else if (v.length > 1000) {
            a.e = $T('validation.len_max_str', { max: 1000 });
            return false;
          }
        } else if (q.t == 's') {
          var v = a.v;
          if (!v && !q.o) {
            a.e = $T('validation.select');
            return false;
          }
        } else if (q.t == 'm') {
          var v = a.vs;
          if (v.length == 0 && !q.o) {
            a.e = $T('validation.select');
            return false;
          }
        }
        break;
      }
      this.reflect();
      return true;
    },
    initAnswer(post) {
      this.qs = null;
      var self = this;
      var qs = [];
      for (var rq of post.content.qs) {
        var q = {};
        q.q = { v: rq.q, md5: md5(this.$utils.removeSpace(rq.q)) };
        q.t = rq.t;
        q.o = rq.o;
        if (['s', 'm'].indexOf(q.t) != -1) {
          q.as = [];
          for (var ra of rq.as) q.as.push({ v: ra, md5: md5(this.$utils.removeSpace(ra)) });
        }
        qs.push(q);
        if (!this.data.ans[q.q.md5]) this.data.ans[q.q.md5] = { t: null, v: null, vs: [] };
      }

      if (post.answered) {
        // set past answer.
        var key = 'psa-' + post.id;
        var self = this;
        this.$commin.clientdb.getObject(key, function(data) {
          if (!data || data.t < post.expire_at) {
            if (data) self.setOldAnswer(post, data.a);
            getSelfAnswer(post.id)
              .then(function(a) {
                $commin.clientdb.putObject(key, {
                  t: Math.floor(Date.now() / 1000),
                  a: a.answer.a,
                });
                self.setOldAnswer(post, a);
              })
              .catch(function(e) {
                console.error(`failed to get answer data from pid[${post.id}]`, e);
                self.errGetData();
              });
            return;
          }

          self.setOldAnswer(post, data.a);
          self.answerLoading = false;
        });
      }

      this.qs = qs;
    },
    setOldAnswer(post, ans) {
      if (this.post.id != post.id) return;
      var da = this.data.ans;
      for (var k of Object.keys(ans)) {
        if (!da[k]) da[k] = { t: null, v: null, vs: [] };
        if (ans[k].t == 't') da[k].t = ans[k].v;
        else if (ans[k].t == 's') da[k].v = ans[k].v;
        else if (ans[k].t == 'm') da[k].vs = ans[k].v;
      }
      this.reflect();
    },
    onClicked() {
      this.loading = true;
      var self = this;
      this.$validator.validateAll().then(result => {
        if (!result) return (self.loading = false);
        self.postData();
      });
    },
    postData() {
      if (this.isGuest) return;
      var d = this.data;

      // validate
      var valid = true;
      var ans = {};
      for (var q of this.qs) {
        var md5 = q.q.md5;
        valid = this.validate(md5) && valid;
        if (q.t == 't') ans[md5] = { t: 't', v: cnvl(d.ans[md5].t, '') };
        else if (q.t == 's') ans[md5] = { t: 's', v: cnvl(d.ans[md5].v, '') };
        else if (q.t == 'm') ans[md5] = { t: 'm', v: d.ans[md5].vs };
      }
      this.reflect();
      if (!valid) return (this.loading = false);

      var data = new FormData();
      data.append('pid', this.post.id);
      data.append('ans', JSON.stringify(ans));
      data.append('comment', cnvl(d.comment, ''));

      var self = this;
      answerPostEnquete(data)
        .then(function(post) {
          self.$emit('modified', post);
          self.post = post;
          self.doAnswer = false;
          self.loading = false;
          var key = 'psa-' + post.id;
          $commin.clientdb.putObject(key, {
            t: Math.floor(Date.now() / 1000),
            a: ans,
          });
          if (self.qas) self.onShowResultClicked();
        })
        .catch(function(e) {
          console.error('failed to answer post data for pid[' + self.post.id + ']', e);
          self.errRegisterData();
          self.loading = false;
        });
    },
    onShowResultClicked() {
      var resultLoading = true;
      var key = 'pea-' + this.post.id;
      var self = this;
      this.$commin.clientdb.getObject(key, function(data) {
        if (!data || data.t < self.post.expire_at) {
          getEnqueteAnswer(self.post.id)
            .then(function(r) {
              $commin.clientdb.putObject(key, {
                t: Math.floor(Date.now() / 1000),
                r: r,
              });
              self.qas = r;
              self.resultLoading = false;
            })
            .catch(function(e) {
              console.error(`failed to get result data for pid[${self.post.id}]`, e);
              if (data) self.qas = r;
              else self.errGetData();
              self.resultLoading = false;
            });
          return;
        }

        self.qas = data.r;
        self.resultLoading = false;
      });
    },
    reflect() {
      // this is not good way
      this.data.d = this.data.d.length == 0 ? ' ' : '';
    },
    toComment(c) {
      return formatExplain(c);
    },
  },
};
</script>

<style scoped>
.c-post {
  padding-bottom: 20px;
}

.c-confirm-btn {
  min-width: 200px;
}
.c-btn {
  text-align: center;
  padding: 0 0 10px 0;
}
.le-tbs .c-btn {
  padding: 0 0 10px 0;
}
.c-result-btn {
  text-align: center;
  padding: 0 0 10px 0;
}

.c-list {
  overflow-x: hidden;
}

.c-msg {
  margin-bottom: 20px;
}
.c-q {
  margin-bottom: 10px;
  padding: 0 16px 16px 16px;
}
.c-ql {
  width: 40px;
  font-size: 16px;
  font-weight: 600;
}
.c-qc {
  font-size: 16px;
  font-weight: 600;
}

.c-explain {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  margin: 10px 0 10px 0;
}
.c-om-ttl {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.72);
  font-weight: 600;
}
.c-om-r {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.72);
  padding-left: 10px;
}
.c-required {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 3px;
}
.c-ans-area {
  padding: 10px 0 0 10px;
}
.c-dummy {
  display: none;
}
.c-qa-title {
  margin: 10px 0;
  font-size: 16px;
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  width: 100%;
  text-align: center;
}
.c-qa-comment {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  padding: 10px 5px;
}

.c-nodata {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  width: 100%;
  padding-bottom: 10px;
}
</style>
